export function runFieldValidators(validators, values) {
  const errors = {};

  validators.forEach(({ field, label = field, validator }) => {
    if (typeof validator !== "function") {
      return;
    }

    const message = validator(values[field], values);
    if (message) {
      errors[field] = message.replace("{label}", label);
    }
  });

  return errors;
}

export function requiredField(label = "This field") {
  return (value) => {
    if (value === undefined || value === null || String(value).trim() === "") {
      return `${label} is required`;
    }
    return null;
  };
}

export function positiveNumberField(label = "Value") {
  return (value) => {
    const numeric = parseFloat(value);
    if (Number.isNaN(numeric) || numeric <= 0) {
      return `${label} must be greater than 0`;
    }
    return null;
  };
}
